<head>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
    integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
    crossorigin="anonymous" referrerpolicy="no-referrer" />
</head>
<div class="d-flex justify-content-between">
  <div>
    <app-breadcrumb></app-breadcrumb>
  </div>  
  <div class="d-flex gap-4 align-items-top">
    <div class="backIconContiner" (click)="backToPreviousPage()" (keydown.enter)="backToPreviousPage()" matTooltip="Go back">
      <i class="fa fa-arrow-left"></i>
    </div>
  </div>
</div>
<div class="table-container grid-content" *ngIf="dynamicLabel">
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <div id="serach-field-container" class="row">
    <div class="col-md-3">
      <!-- Group Name -->
      <div><label for="email">{{dynamicLabel['GROUP_NAME']}}</label><span class="mandatory-symbol">*</span></div>
      <input id="groupName" class="search-filed-continers uppercase" type="text"
        [(ngModel)]="trainingGroupFieldData.groupName" (keypress)="allowOnlyAllowedChars($event)">
      <span id="groupName-required-msg">Please enter the Group Name</span>
    </div>
    <div class="col-md-3">
      <!-- Addl Due Reminder Emails -->
      <div><label for="email">{{dynamicLabel['ADDL_DUE_REMINDER_EMAILS']}}</label></div>
      <input class="search-filed-continers" type="text" [(ngModel)]="trainingGroupFieldData.addlDueReminderEmails">
    </div>
    <div class="col-md-3">
      <!-- Addl Due Escalation Emails -->
      <div><label for="email">{{dynamicLabel['ADDL_DUE_ESCALATION_EMAILS']}}</label></div>
      <input class="search-filed-continers" type="text" [(ngModel)]="trainingGroupFieldData.addlDueEscalationEmails">
    </div>
    <div class="col-md-3">
      <!-- Max Attempt Escalation Emails -->
      <div><label for="email">{{dynamicLabel['MAX_ATTEMPT_ESCALATION_EMAILS']}}</label></div>
      <input class="search-filed-continers" type="text"
        [(ngModel)]="trainingGroupFieldData.maxAttemptEscalationEmails">
    </div>
    <div class="col-md-6">
      <!-- Group Description -->
      <div><label for="email ">{{dynamicLabel['GROUP_DESCRIPTION']}}</label></div>
      <textarea id="description" rows="4" class="input-filed-textarea" type="text"
        [(ngModel)]="trainingGroupFieldData.groupDescription"></textarea>
    </div>
    <div class="col-md-3">
      <!-- CC Reminder Email To RM -->
      <div><label for="email">{{dynamicLabel['CC_REMINDER_EMAIL_TO_RM']}}</label></div>
      <mat-slide-toggle color="primary" [(ngModel)]="trainingGroupFieldData.ccReminderEmailToRm">
        <span class="active-inActive-container" *ngIf="trainingGroupFieldData.ccReminderEmailToRm==true"
          [ngStyle]="trainingGroupFieldData.ccReminderEmailToRm==true?{'color':'green'} : {'color': ''}">Active</span>
        <span *ngIf="trainingGroupFieldData.ccReminderEmailToRm==false"
          [ngStyle]="trainingGroupFieldData.ccReminderEmailToRm==false?{'color':'red'} : {'color': ''}">InActive</span>
      </mat-slide-toggle>
    </div>
   <div class="col-md-3">
      <!-- Is Active? -->
      <div><label for="email">{{dynamicLabel['CC_EMAIL_TO_RM']}}</label></div>
      <mat-slide-toggle color="primary" [(ngModel)]="trainingGroupFieldData.ccEmailToRm">
        <span class="active-ccEmailToRm-container" *ngIf="trainingGroupFieldData.ccEmailToRm==true"
          [ngStyle]="trainingGroupFieldData.ccEmailToRm==true?{'color':'green'} : {'color': ''}">Active</span>
        <span *ngIf="trainingGroupFieldData.ccEmailToRm==false"
          [ngStyle]="trainingGroupFieldData.ccEmailToRm==false?{'color':'red'} : {'color': ''}">InActive</span>
      </mat-slide-toggle>
    </div>
    <div class="col-md-3">
      <!-- Is Active? -->
      <div><label for="email">{{dynamicLabel['IS_ACTIVE']}}</label></div>
      <mat-slide-toggle color="primary" [(ngModel)]="trainingGroupFieldData.isActive">
        <span class="active-inActive-container" *ngIf="trainingGroupFieldData.isActive==true"
          [ngStyle]="trainingGroupFieldData.isActive==true?{'color':'green'} : {'color': ''}">Active</span>
        <span *ngIf="trainingGroupFieldData.isActive==false"
          [ngStyle]="trainingGroupFieldData.isActive==false?{'color':'red'} : {'color': ''}">InActive</span>
      </mat-slide-toggle>
    </div>

    <div class="col-md-3">
      <!-- Group Name -->
      <div><label for="email">Update Reason</label><span class="mandatory-symbol">*</span></div>
        <textarea id="update" rows="3" class="textarea-filed-continers" type="text"
            [(ngModel)]="trainingGroupFieldData.updateReason"></textarea>
      <span id="update-required-msg">Please enter update reason</span>
    </div>
  </div>
  <br><br>
  <div class="button-continer" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="updateTrainingGroup(trainingGroupFieldData)">
      <i class="fas fa-user-edit"></i> Update
    </button>
    <button style="margin-left: 1%;" mat-stroked-button class="cancelButton" (click)="backToTrainingGroup()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</div>

<br>

<div class="row">
  <div class="col-md-12">
    <mat-tab-group mat-stretch-tabs class="trainingtab mat-tab-container mat-elevation-z4" animationDuration="0ms"
      (selectedTabChange)="onTabChanged($event);">
      <mat-tab label="Users">
        <ng-template mat-tab-label>
          <span>Users</span>
        </ng-template>
        <app-tms-group-users [trainingGroupdata]="trainingGroupFieldData"></app-tms-group-users>
      </mat-tab>
      <mat-tab label="Trainings">
        <ng-template mat-tab-label>
          <span>Trainings</span>
        </ng-template>
        <app-tms-group-trainings *ngIf="isShowTrainingsGrid"
          [trainingGroupdata]="trainingGroupFieldData"></app-tms-group-trainings>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>